<template>
  <div class="grid w-12 container-particle sm:w-full">
    <div
      class="lg:col-offset-1 flex flex-row align-items-center h-8rem border-gray-300 bg-morphism-2 md:col-12 shadow-3 bg-morphism-2 bg-pattern fadein animation-duration-1000 animation-iteration-1 mt-3 md:w-6 sm:w-10 mr-4"
    >
      <i alt="face-icon" class="pi pi-user text-6xl ml-6 text-gray-700" />
      <div
        id="welcome-message"
        class="flex flex-column font-normal ml-6 lg:text-2xl fadeinright animation-duration-1000 animation-iteration-1"
      >
        <h3 class="justigy-seld-end" style="color: #2563eb">
          {{ grettingsMessageBasedOnTime() }}
        </h3>
        <label class="font-medium text-bluegray-600">{{ user?.name }}</label>
      </div>
    </div>
    <div
      v-for="moduleItem of items"
      class="grid lg:col-10 sm:col-12 mt-3"
      style="margin: 0px auto"
    >
      <span class="font-medium text-700">
        Módulos de {{ moduleItem.label }}
      </span>
      <Divider />
      <div
        v-for="subItem of moduleItem.items"
        class="col-10 md:col-4 lg:col-3 bg-red flex flex-column m-3 border-round-sm h-8rem text-white justify-content-center align-items-center cursor-pointer fadein animation-duration-1000 animation-iteration-1 shadow-3 bg-morphism hover:bg-gray-200"
        @click="router.push(subItem.to)"
      >
        <div
          class="flex flex-column align-items-center justify-content-center text-center"
        >
          <i
            alt="face-icon"
            :class="subItem.icon"
            class="text-4xl text-gray-600"
          ></i>
          <span class="mt-3 font-normal" style="color: #2563eb">{{
            subItem.label
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { useUserStore } from '@/store/user'
  import { storeToRefs } from 'pinia'
  import { onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'
  const { user } = storeToRefs(useUserStore())

  const router = useRouter()
  const items = ref()

  onMounted(async () => {
    items.value = user.value?.modules || []
  })

  const grettingsMessageBasedOnTime = () => {
    const date = new Date()
    const hours = date.getHours()
    if (hours >= 0 && hours < 12) {
      return 'Buenos días'
    } else if (hours >= 12 && hours < 19) {
      return 'Buenas tardes'
    } else {
      return 'Buenas noches'
    }
  }
</script>
<style scoped>
  .container-particle > div {
    position: relative;
  }

  .color-gradient {
    background: linear-gradient(
      45deg,
      rgb(40, 42, 150) 0%,
      rgb(42, 167, 245) 100%
    );
  }

  .bg-morphism {
    background: #e9ecef;
    backdrop-filter: blur(19.5px);
    -webkit-backdrop-filter: blur(19.5px);
    border-radius: 10px;
  }

  .bg-morphism-2 {
    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.61);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.91);
  }

  .bg-pattern {
    background-image: url('../../assets/pattern.png');
    background-repeat: repeat;
    background-size: auto;
    background-position: right;
  }

  @media (max-width: 768px) {
    .container-particle {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>
